import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-trust-dark py-16 sm:py-24" aria-labelledby="guarantee-title" data-id="element-79" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-3xl px-6" data-id="element-80" data-mp="22368jta2e3s9">
        <h2 id="guarantee-title" className="text-center text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-81" data-mp="222wjq90ra2o5">
          The Only Risk Here Is Closing This Page Without Taking Action.
        </h2>

        <div className="mt-10 rounded-3xl border border-white/20 bg-white/10 p-8 text-center sm:p-12" data-id="element-82" data-mp="14fxtoh4kjsz8">
          <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-white text-trust-dark shadow-lg" data-id="element-83" data-mp="1j52d21n3o38x">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-84" data-mp="1ed26hqciyc3d" />
          </span>
          <p className="mt-6 text-lg font-extrabold uppercase tracking-wide text-white" data-id="element-85" data-mp="qn7tn8s7gnj4">
            Complete 7-Day Money-Back Guarantee
          </p>

          <div className="mx-auto mt-6 max-w-2xl space-y-4 text-left text-base leading-relaxed text-emerald-50" data-id="element-86" data-mp="lnc063h4weht">
            <p data-id="element-87" data-mp="tymf0008r8v0">
              We are so certain that The Pharma-Masterclave will change how you manage your home
              pharmacy that we offer a complete 7-day money-back guarantee.
            </p>
            <p className="font-semibold text-white" data-id="element-88" data-mp="12qof1x6een4r">
              Go through the system. Run the audit. Implement the protocols.
            </p>
            <p data-id="element-89" data-mp="628cn0i6wja8">
              If you don’t find at least 3 immediate improvements to make in your cabinet — simply
              contact us at{' '}
              <a href="mailto:soporte.digitaltoolkit@gmail.com" className="font-semibold text-white underline decoration-white/50 underline-offset-2 hover:decoration-white" data-id="element-90" data-mp="f1lpm35ivpzp">
                soporte.digitaltoolkit@gmail.com
              </a>{' '}
              and we will refund 100% of your purchase.
            </p>
            <p className="font-semibold text-white" data-id="element-91" data-mp="1vdr29t5mjbfp">No questions. No conditions. No risk.</p>
            <p data-id="element-92" data-mp="3rgx42wq9ufgj">
              The only thing you risk by not acting today is leaving your family’s medications
              exactly as they are right now.
            </p>
          </div>
        </div>
      </div>
    </section>;
}